import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import ThemeProvider from 'components/Theme';
import Home from 'components/Home/Home';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import NoMatch from 'components/NoMatch';
import '../App.css';

const styles = (theme) => {
  return {

  }
}
class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
  }
  render() {

    const {
      classes,
    } = this.props;

    return (
      <Router>
        <div className="App" id="App">
          <ThemeProvider>
            <ScrollToTopOnMount/>
            <Switch>
              <Route exact path={'/'} component={({match}) => (<Home onPanelToggle={this._panelToggle}/>)}/>
              <Route component={NoMatch} />
            </Switch>
          </ThemeProvider>
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const props = {
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js